import { React } from 'react';
import { Modal } from '@mantine/core';

// Contenu des mentions légales, en dur (remplace l'ancien PDF Cloudinary).
// Affiché à la fois sur la landing (Footer) et dans l'app (Disclaimer) via ce composant partagé.
const MentionsLegalesModal = ({ opened, onClose }) => {
    return (
        <Modal opened={opened} onClose={onClose} title="Mentions légales" size="lg" centered>
            <div className="vertical" style={{ fontFamily: "'Roboto', sans-serif", fontSize: 13 }}>
                <p className='medium noMrgT mrgB5'>1. Éditeur du site</p>
                <p className='noMrgTB'>
                    Le site Boldee.co est édité par ECRIN, Société par Actions Simplifiée (SAS) au capital de 30 000 €,
                    dont le siège social est situé Bureau 562, 78 avenue des Champs-Élysées, 75008 Paris, immatriculée
                    au Registre du Commerce et des Sociétés (RCS) de Paris sous le n° 903 217 222.
                </p>
                <p className='noMrgTB mrgT10'>
                    Directrice de la publication : Enine Chareunsouk.
                </p>
                <p className='noMrgTB mrgT10'>
                    Contact : contact@boldee.co
                </p>

                <p className='medium mrgB5 mrgT20'>2. Hébergement</p>
                <p className='noMrgTB'>
                    Le site Boldee.co est hébergé par Heroku Inc., 650 7th Street, San Francisco, CA, États-Unis.
                </p>
                <p className='noMrgTB mrgT10'>
                    Les données personnelles des utilisateurs sont stockées sur les serveurs d'Amazon Web Services
                    (Amazon Inc., 410 Terry Avenue North, Seattle, WA, États-Unis), localisés dans des États membres
                    de l'Union Européenne.
                </p>
                <p className='noMrgTB mrgT10'>
                    Les images et fichiers du site sont hébergés par Cloudinary Ltd, sur des serveurs localisés en Europe.
                </p>

                <p className='medium mrgB5 mrgT20'>3. Propriété intellectuelle</p>
                <p className='noMrgTB'>
                    L'ensemble des contenus du site et de l'application Boldee (textes, graphismes, logos, images,
                    structure) est la propriété d'ECRIN et est protégé par le Code de la propriété intellectuelle.
                    Toute reproduction ou exploitation, totale ou partielle, sans autorisation écrite préalable est
                    interdite et peut constituer une contrefaçon au sens de l'article L.335-2 du Code de la propriété
                    intellectuelle.
                </p>

                <p className='medium mrgB5 mrgT20'>4. Données personnelles</p>
                <p className='noMrgTB'>
                    Le traitement des données personnelles des utilisateurs est effectué conformément au Règlement
                    (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés du 6 janvier 1978 modifiée.
                </p>
                <p className='noMrgTB mrgT10'>
                    Pour toute question ou demande relative à vos données personnelles, vous pouvez contacter Enine
                    Chareunsouk à l'adresse contact@boldee.co.
                </p>

                <p className='medium mrgB5 mrgT20'>5. Modification</p>
                <p className='noMrgTB'>
                    ECRIN se réserve le droit de modifier les présentes mentions légales à tout moment.
                </p>
            </div>
        </Modal>
    );
};

export default MentionsLegalesModal;
